const ChartEmptyLabel = () => (
    <g />
);

export default ChartEmptyLabel;